import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

/**
 * @title Chips Autocomplete
 */
@Component({
  selector: 'app-tags-chips',
  templateUrl: 'tags-chips.component.html',
  styleUrls: ['tags-chips.component.scss'],
})
export class TagsChipsComponent implements OnInit {
  @Input() selectedValues: string[] = [];
  @Input() allValues: string[] = [];
  @Input() label: string;
  @Input() selectOnly: boolean;
  @Output() onValueChange = new EventEmitter<string[]>();

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fControl = new FormControl();
  filteredValues: Observable<string[]>;

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor() {}

  ngOnInit(): void {
    this.filteredValues = this.fControl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filter(fruit) : this.allValues.slice()));
  }

  add(event: MatChipInputEvent): void {
    if (this.selectOnly) {
      return;
    }
    const input = event.input;
    const value = event.value;

    // Add our value
    if ((value || '').trim() && this.selectedValues.indexOf(value) === -1 ) {
      this.selectedValues.push(value.trim());
      this.onValueChange.emit(this.selectedValues);
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.fControl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.selectedValues.indexOf(fruit);

    if (index >= 0) {
      this.selectedValues.splice(index, 1);
      this.onValueChange.emit(this.selectedValues);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.selectedValues.indexOf(event.option.viewValue) === -1) {
      this.selectedValues.push(event.option.viewValue);
      this.onValueChange.emit(this.selectedValues);
    }
    this.fruitInput.nativeElement.value = '';
    this.fControl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.allValues.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }
}
